//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {isApp, OpenApp} from '@/util/const'

export default {
    name: "topUp",
    data() {
        return {
            lang:''
        }
    },
    methods: {
        urlJump() {
            let url = `openhkhshlogin://cmcchkhsh://valueAddedService`
            this.open(url)
        },
        // 跳转方法
        open(link, umkey) {
            if (isApp()) {
                window.location.href = link
            } else {
                OpenApp(link)
            }
        },
    },
    created() {
        this.lang = window.localStorage.lang
        document.title = this.$t('other.topUp.title')
    }
}



// WEBPACK FOOTER //
// ./src/page/other/topUp.vue